import { useQuery } from '@tanstack/react-query'
import navService from '@api/v1/navService'
import useAppStore from '@store/appStore'

// Fetch the tenant's object types once and stash them in appStore. Lives in a
// hook (not the Sidebar) so it runs whether or not the sidebar is rendered:
// reports-only mode (spec 032) hides the sidebar, but the Objects page and
// ObjectList still read appStore.objectTypes. Keyed query → deduped/cached, so
// it's safe to mount from the Layout regardless of route.
export default function useObjectTypes() {
  const setObjectTypes = useAppStore((s) => s.setObjectTypes)
  return useQuery({
    queryKey: ['objectTypes'],
    queryFn: async () => {
      const types = await navService.getObjectTypes()
      setObjectTypes(types)
      return types
    },
    staleTime: 5 * 60 * 1000, // cache for 5 min
    retry: 1,
  })
}
